"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var DialogContent_1 = require("@mui/material/DialogContent");
var DialogActions_1 = require("@mui/material/DialogActions");
var Button_1 = require("@mui/material/Button");
var Dialog_1 = require("@mui/material/Dialog");
var FormGroup_1 = require("@mui/material/FormGroup");
var Typography_1 = require("@mui/material/Typography");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../../Types");
var components_1 = require("@athena-portal/components");
var WriteOffInvoiceAction = /** @class */ (function (_super) {
    __extends(WriteOffInvoiceAction, _super);
    function WriteOffInvoiceAction(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleWriteOffPopupModal = function () {
            _this.setState(function (prevState) { return ({
                showWriteOffPopup: !prevState.showWriteOffPopup
            }); });
        };
        _this.writeOffInvoice = function () {
            _this.supportPortalService
                .writeOffInvoice(_this.props.customerReferenceNumber, _this.props.policyNumber, _this.props.invoice.id)
                .subscribe(function () {
                _this.props.getInvoiceAndPaymentData();
                _this.props.setUpdatedInvoiceId(_this.props.invoice.id);
            });
        };
        _this.doConfirmation = function () {
            _this.toggleWriteOffPopupModal();
            _this.writeOffInvoice();
            _this.supportPortalService.logAgentActivity(_this.props.customerReferenceNumber, {
                "action": "Write off: Invoice ".concat(_this.props.invoice.id, " written-off"),
                "customer": _this.props.policyNumber
            }).subscribe();
        };
        _this.state = {
            showWriteOffPopup: false
        };
        return _this;
    }
    WriteOffInvoiceAction.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Dialog_1.default, { open: this.state.showWriteOffPopup, onClose: this.toggleWriteOffPopupModal, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [(0, jsx_runtime_1.jsx)(DialogContent_1.default, { className: "pb-0 text-center", children: (0, jsx_runtime_1.jsx)(FormGroup_1.default, { children: (0, jsx_runtime_1.jsxs)(Typography_1.default, { className: "p-2", variant: "subtitle1", children: ["Do you really want to write-off invoice ", (0, jsx_runtime_1.jsx)("b", { children: this.props.invoice.id }), " for \u00A3", (0, jsx_runtime_1.jsx)("b", { children: Math.abs(this.props.invoice.amount) }), "?"] }) }) }), (0, jsx_runtime_1.jsxs)(DialogActions_1.default, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, { onClick: this.toggleWriteOffPopupModal, color: "primary", children: "CANCEL" }), (0, jsx_runtime_1.jsx)(Button_1.default, { onClick: this.doConfirmation, color: "primary", children: "OK" })] })] }), (0, jsx_runtime_1.jsx)(components_1.FontAwesomeIcon, { icon: "times", className: "fa-lg icon-spacing", onClick: this.toggleWriteOffPopupModal, type: "light", title: "Write off invoice" })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], WriteOffInvoiceAction.prototype, "supportPortalService", void 0);
    WriteOffInvoiceAction = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "CSR_Lead"),
        __metadata("design:paramtypes", [Object])
    ], WriteOffInvoiceAction);
    return WriteOffInvoiceAction;
}(React.Component));
exports.default = WriteOffInvoiceAction;
//# sourceMappingURL=WriteOffInvoiceAction.js.map